import {
  formatDeltaPercentageText,
  formatLastPeriodLabel,
} from "@/react/components/Analytics/components/utils/format";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { TREND_NEGATIVE_CLASSES, TREND_POSITIVE_CLASSES } from "./constants";

interface TrendDeltaProps {
  className?: string;
  deltaPercentage: number;
  lastPeriodValue?: number | string;
  suffix?: string;
  withBackground?: boolean;
}

export const TrendDelta = ({
  deltaPercentage,
  withBackground = true,
  lastPeriodValue,
  suffix,
  className,
}: TrendDeltaProps) => {
  const isPositive = deltaPercentage >= 0;

  const { containerBg, textClass, iconType } = isPositive
    ? TREND_POSITIVE_CLASSES
    : TREND_NEGATIVE_CLASSES;

  const deltaText = formatDeltaPercentageText(deltaPercentage);
  const lastPeriodLabel = formatLastPeriodLabel(lastPeriodValue, suffix);

  const containerClasses = withBackground
    ? classNames(
        "inline-flex items-center justify-start gap-1 rounded-md px-1 py-0.5",
        containerBg,
        className,
      )
    : classNames("inline-flex items-center gap-1", className);

  return (
    <div className={classNames("inline-flex items-center gap-2", className)}>
      <div className={classNames(containerClasses, textClass)}>
        <div
          className={classNames(
            "size-3",
            "flex items-center justify-center overflow-visible",
          )}
        >
          <Icon
            type={iconType}
            size={12}
            className={classNames("block")}
            useWithStrokeCurrentColor
          />
        </div>
        <span
          className={classNames(
            "leading-4.5 text-xs font-medium tracking-[0.2px]",
          )}
        >
          {deltaText}
        </span>
      </div>
      {lastPeriodLabel ? (
        <Typography.LabelXs color="text-default">
          {lastPeriodLabel}
        </Typography.LabelXs>
      ) : null}
    </div>
  );
};
